<template>
  <div id="gallery-main list-complete" class="container">
    <div class="gallery-main__inner">
      <div class="row filter-buttons">
        <b-button class="submit" variant="primary" v-on:click="filter('all')"
          >All</b-button
        >
        <b-button
          class="submit"
          variant="primary"
          v-on:click="filter('andaluza')"
          >Villa Andaluza</b-button
        >
        <b-button
          class="submit"
          variant="primary"
          v-on:click="filter('veranza')"
          >Villa Veranza</b-button
        >
        <b-button
          class="submit"
          variant="primary"
          v-on:click="filter('bluebay')"
          >Blue Bay</b-button
        >
      </div>
      <div class="row">
        <transition-group
          name="list-complete"
          class="list-complete"
          tag="section"
        >
          <div
            v-for="item in filteredItems"
            v-bind:key="item.id"
            class="list-complete-item"
          >
            <div class="card">
              <img
                ref="gallery-image"
                class="list-complete-img"
                :src="item.img"
                alt
                @click="showModal(item.id)"
                v-b-modal="'gallery-modal'"
              />
            </div>
          </div>
        </transition-group>

        <b-modal ref="imgModal" id="gallery-modal">
          <b-carousel
            no-animation
            id="carousel-1"
            v-model="slide"
            controls
            background="#ababab"
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
            class="carousel-gallery"
          >
            <b-carousel-slide
              v-for="slides in items"
              v-bind:key="slides.id"
              class="carousel__mobile"
              :img-src="items[selectedImageID].img"
            ></b-carousel-slide>
          </b-carousel>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
3;
export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      items: [
        {
          id: 0,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-1-min.jpg"),
        },
        {
          id: 1,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-2-min.jpg"),
        },
        {
          id: 2,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-3-min.jpg"),
        },
        {
          id: 3,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-4-min.jpg"),
        },
        {
          id: 4,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-5-min.jpg"),
        },
        {
          id: 5,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-6-min.jpg"),
        },
        {
          id: 6,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-7-min.jpg"),
        },
        {
          id: 7,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-8-min.jpg"),
        },
        {
          id: 8,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-9-min.jpg"),
        },
        {
          id: 9,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-10-min.jpg"),
        },
        {
          id: 10,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-11-min.jpg"),
        },
        {
          id: 11,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-12-min.jpg"),
        },
        {
          id: 12,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-13-min.jpg"),
        },
        {
          id: 13,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-14-min.jpg"),
        },
        {
          id: 14,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-15-min.jpg"),
        },
        {
          id: 15,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-16-min.jpg"),
        },
        {
          id: 16,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-17-min.jpg"),
        },
        {
          id: 17,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-18-min.jpg"),
        },
        {
          id: 18,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-19-min.jpg"),
        },
        {
          id: 19,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-20-min.jpg"),
        },
        {
          id: 20,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-21-min.jpg"),
        },
        {
          id: 21,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-22-min.jpg"),
        },
        {
          id: 22,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-23-min.jpg"),
        },
        {
          id: 23,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-24-min.jpg"),
        },
        {
          id: 24,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-25-min.jpg"),
        },
        {
          id: 25,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-26-min.jpg"),
        },
        {
          id: 26,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-27-min.jpg"),
        },
        {
          id: 27,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-28-min.jpg"),
        },
        {
          id: 28,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-29-min.jpg"),
        },
        {
          id: 29,
          tags: ["all", "andaluza"],
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-30-min.jpg"),
        },
        {
          id: 30,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-1-min.jpg"),
        },
        {
          id: 31,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-2-min.jpg"),
        },
        {
          id: 32,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-3-min.jpg"),
        },
        {
          id: 33,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-4-min.jpg"),
        },
        {
          id: 34,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-5-min.jpg"),
        },
        {
          id: 35,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-6-min.jpg"),
        },
        {
          id: 36,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-7-min.jpg"),
        },
        {
          id: 37,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-8-min.jpg"),
        },
        {
          id: 38,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-9-min.jpg"),
        },
        {
          id: 39,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-10-min.jpg"),
        },
        {
          id: 40,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-11-min.jpg"),
        },
        {
          id: 41,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-12-min.jpg"),
        },
        {
          id: 42,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-13-min.jpg"),
        },
        {
          id: 43,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-14-min.jpg"),
        },
        {
          id: 44,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-15-min.jpg"),
        },
        {
          id: 45,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-16-min.jpg"),
        },
        {
          id: 46,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-17-min.jpg"),
        },
        {
          id: 47,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-18-min.jpg"),
        },
        {
          id: 48,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-19-min.jpg"),
        },
        {
          id: 49,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-20-min.jpg"),
        },
        {
          id: 50,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-21-min.jpg"),
        },
        {
          id: 51,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-22-min.jpg"),
        },
        {
          id: 52,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-23-min.jpg"),
        },
        {
          id: 53,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-24-min.jpg"),
        },
        {
          id: 54,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-25-min.jpg"),
        },
        {
          id: 55,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-26-min.jpg"),
        },
        {
          id: 56,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-27-min.jpg"),
        },
        {
          id: 57,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-28-min.jpg"),
        },
        {
          id: 58,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-29-min.jpg"),
        },
        {
          id: 59,
          tags: ["all", "veranza"],
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-30-min.jpg"),
        },
        {
          id: 60,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/301/blue_bay_bedroom.jpeg"),
        },
        {
          id: 61,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/301/blue_bay_living.jpeg"),
        },
        {
          id: 62,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/301/blue_bay_living_2.jpeg"),
        },
        {
          id: 63,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/301/blue_bay_kitchen.jpeg"),
        },
        {
          id: 64,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/301/blue_bay_tv.jpeg"),
        },
        {
          id: 6,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/301/blue_bay_extra_room.jpeg"),
        },
        {
          id: 66,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/301/blue_bay_courts.jpeg"),
        },
        {
          id: 67,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/302/blue_bay_master_302.jpeg"),
        },
        {
          id: 68,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/302/blue_bay_spare_302.jpeg"),
        },
        {
          id: 69,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/302/blue_bay_living_302.jpeg"),
        },
        {
          id: 70,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/302/blue_bay_living_2_302.jpeg"),
        },
        {
          id: 71,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/302/blue_bay_dining_302.jpeg"),
        },
        {
          id: 72,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/302/blue_bay_bath_302.jpeg"),
        },
        {
          id: 73,
          tags: ["all", "bluebay"],
          img: require("../assets/gallery/villas/blue_bay/web/302/blue_bay_balcony_302.jpeg"),
        },
      ],
      currentTag: "all",
      selectedImageID: 0,
    };
  },
  computed: {
    filteredItems: function() {
      var filter = this.currentTag;
      return this.items.filter(function(item) {
        return item.tags.indexOf(filter) !== -1;
      });
    },
  },
  methods: {
    filter: function(tag) {
      this.currentTag = tag;
    },
    showModal(id) {
      this.selectedImageID = id;
    },
    onSlideStart() {
      this.sliding = true;
      this.selectedImageID = this.selectedImageID + 1;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
};
</script>

<style lang="scss">
@import "../styles/main";
.carousel-gallery img {
  margin-top: 0px;
}
.modal-footer {
  display: none !important;
}
.list-complete {
  height: 100%;
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
}
.list-complete-item {
  transition: transform 1s;
  flex: 1 1 25%;
  height: auto;
  padding: 10px;
}
.list-complete-img {
  object-fit: cover;
  height: 100%;
  width: 100%;
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}

.gallery-main {
  margin-bottom: 20px;
  height: auto !important;

  &__inner {
    height: auto !important;
  }
}

.modal-dialog {
  max-width: 70% !important;
  @media only screen and (max-width: 1000px) {
    max-width: 100% !important;
  }
  img {
    width: 100%;
  }
}
.filter-buttons {
  justify-content: center;
  margin-bottom: 40px;
  button {
    background-color: $bg--blue;
    border-color: $bg--blue;
    margin-left: 20px;
    font-weight: 600;
    @media only screen and (max-width: 1000px) {
      margin-left: 2px;
      margin-right: 2px;
      font-size: 12px;
    }
  }
  @media only screen and (max-width: 1000px) {
    flex-wrap: nowrap !important;
  }
}
</style>
